/* eslint-disable */

import { useEffect, useState } from 'react';
import ChatBot from './pages/chat';
import ThemeProvider from './theme';
import { getAgentConverationNOLOGINFetch, getChatBotGlobalParamsFetch, getAllConversationsFetch, getBotConfigsFetch } from "./fetch/index/agentNew"
import { checkEmail, checkPhone } from "./commons/helps";

let time;
const newInitData = {
  headerTitle: "Burstyai.com", // 头部标题
  headerBgColor: "#000000", // 头部背景颜色
  headerTextColor: "#ffffff", // 头部文字颜色
  botAvatar: "20", // 机器人头像
  userAvatar: "12", // 用户聊天头像
  btnBgColor: "#212B36", // 按钮 背景
  btnTextColor: "#ffffff", // 按钮文字颜色
  fabAnimation: "twinkle", // 悬浮按钮动效
  contentBg: "#f0f0f0", // 聊天框背景
  botMessageBg: "#ffffff", // 聊天框 机器人消息背景
  botMessageText: "#212B36", // 聊天框 机器人消息背景
  userMessageBg: "#212b36", // 聊天框 用户消息背景
  userMessageText: "#ffffff", // 聊天框 机器人消息背景
  footerBg: "#f5f5fa",  // 底部背景
  placeholder: "Input ...", // 输入框提示占位
  autoPopup: false,//是否自动展开
  popupDelay: 0,//表示用户在某个页面上停留了多少秒之后，就自动打开chatbot聊天框
  removeLogo: false, // 是否移除logo
  customLogoText: "Powered by", // 自定义logo文字
  customLogoWebsite: "https://burstyai.com/", // 自定义logo链接
  customLogoUrl: "https://burstyai.com/images/header-logo-techflow-x-webflow-template.svg", // 自定义logo图片
}
function App(props) {
  localStorage.removeItem("converationId")
  const { publicUUID, businessAccountId, projectId, agentId, type, innerScriptType } = props;
  const locaConverationId = localStorage.getItem(`${projectId}_converationId`)
  const [error, setError] = useState("");
  const [converationId, setConverationId] = useState(null)
  const [globalparams, setGlobalparams] = useState(newInitData)
  const [loading, setLoading] = useState(true);
  const [reloadChatHistory, setReloadChatHistory] = useState(false);
  const [unreadAmount, setUnreadAmount] = useState(0);
  const [lock, setLock] = useState(false);
  const [isShow, setIsShow] = useState(false);

  // 是否开启 询问 提交信息
  const [leadsInfo, setLeadsInfo] = useState([])
  const [leadsWeclome, setLeadsWeclome] = useState("")

  // 获取 样式配置信息
  const getGlobalParams = async () => {
    try {
      const res = await getChatBotGlobalParamsFetch(agentId, { businessAccountId: businessAccountId, projectId: projectId });
      if (res?.botAvatar) {


        // eslint-disable-next-line no-restricted-syntax
        for (const key in res) {
          if (res[key] === null || res[key] === undefined || res[key] === "") {
            delete res[key]
          }
        }
        const newData = { ...newInitData, ...res }
        localStorage.setItem("globalParams", JSON.stringify(newData))
        setGlobalparams(newData)

      }
      setLoading(false)
    } catch (error) { /* empty */ }
  }

  useEffect(() => {
    // if (type === "iframe") {
    //   const storageParams = localStorage.getItem("globalParams")
    //   if (storageParams) {
    //     try {
    //       const jsonStorageParams = JSON.parse(storageParams);
    //       setGlobalparams(jsonStorageParams)
    //       if (agentId) {
    //         getGlobalParams()
    //         getBotconfigs()
    //       }
    //     } catch (error) { }
    //   }
    // } else {
    // }
    if (agentId) {
      getGlobalParams()
      getBotconfigs()
    }


  }, [])

  const getBotconfigs = async () => {
    try {
      const res = await getBotConfigsFetch(agentId, { businessAccountId: businessAccountId, projectId: projectId });
      const setting = res?.leadsSetting;
      const newData = [];
      if (setting.nameShow) {
        newData.push(
          {
            label: setting?.name ?? "Name",
            key: "name",
            value: "",
          },
        )
      }
      if (setting.emailShow) {
        newData.push(
          {
            label: setting?.email ?? "Email",
            key: "email",
            value: "",
          },
        )
      }
      if (setting.phoneShow) {
        newData.push(
          {
            label: setting?.phone ?? "Phone Number",
            key: "phone",
            value: "",
          },
        )
      }
      setLeadsWeclome(setting?.title ?? "Let us know how to contact you")
      setLeadsInfo(newData)
    } catch (error) {

    }
  }


  // 判断 lock 为true则轮询查询数量接口
  useEffect(() => {

    if (lock && type === "iframe" && type === "iframe") {
      loopUnreadAmount()
    }

    return () => time && clearInterval(time);
  }, [lock])

  const loopUnreadAmount = async () => {
    time = setInterval(() => {
      getAllConversations()
    }, 3000);
  }

  const callBackIsShow = (value) => {
    if (type === "iframe") {
      setIsShow(value)
      if (value) {
        if (!isShow && converationId) {
          setReloadChatHistory(true);
        } else if (locaConverationId) {
          setConverationId(locaConverationId)
        }
        else if (!innerScriptType && publicUUID) {
          createNewConversation()
        } else {
          setError("publicUUID Require !")
        }

      } else {

      }
    }
  }

  useEffect(() => {

    if (agentId && projectId && converationId && type === "iframe") {
      getAllConversations()
    }

  }, [converationId])


  // 新建聊天窗口
  const createNewConversation = async (props) => {
    if (publicUUID && type === "iframe") {
      try {
        time && clearInterval(time);
        setLock(false)
        const res = await getAgentConverationNOLOGINFetch({
          publicUUID: publicUUID,
          projectId: projectId,
          businessAccountId: businessAccountId,
        });
        if (res.id) {
          localStorage.setItem(`${projectId}_converationId`, res.id)
          setConverationId(res.id);
        }
      } catch (error) { /* empty */
        console.log(error);
      }
    }
  }

  // 判断是否锁住，锁住的话开始轮询接口
  // 用户刷新 不做处理了
  const callBackLock = (v) => setLock(v)

  const getAllConversations = async () => {
    try {
      const res = await getAllConversationsFetch(converationId);
      if (Number(res) > 0) {
        setUnreadAmount(res);
        if (isShow) {
          setReloadChatHistory(true);
        }
      }
    } catch (error) { /* empty */ }
  }

  return (
    <ThemeProvider >
      <ChatBot
        innerScriptType={innerScriptType}
        styleLoading={loading}
        globalparams={globalparams}
        converationId={converationId}
        createNewConversation={createNewConversation}
        scriptType={type}
        reloadChatHistory={reloadChatHistory}
        reloadChatHistoryCallBack={(e) => setReloadChatHistory(e)}
        callBackLock={callBackLock}
        callBackIsShow={callBackIsShow}
        unreadAmount={unreadAmount}
        leadsInfo={leadsInfo}
        leadsWeclome={leadsWeclome}
        publicUUID={publicUUID}
        businessAccountId={businessAccountId}
        projectId={projectId}
        agentId={agentId}
      />
    </ThemeProvider>
  )
}

export default App;
